import { useQuery } from 'react-query';

import { GqlRequestOptions } from '@common/api-request';

import { GetZonlyEstimateShippingInfoQueryOptionParams } from '../repositories/zonlyEstimamteShippingInfo';
import { zonlyEstimateShippingInfoQueryOption } from '../repositories/zonlyEstimamteShippingInfo';

export const useZonlyEstimateShippingInfo = (
  params: GetZonlyEstimateShippingInfoQueryOptionParams,
  options?: GqlRequestOptions,
) => {
  const queryResponse = useQuery(zonlyEstimateShippingInfoQueryOption(params, options));
  return {
    ...queryResponse,
    pdp_zigzin_shipping_base_info: queryResponse.error || !queryResponse.data ? null : queryResponse.data,
  };
};
